export default function Element$findNextNode () {
	return null;
}
